import Cookies from "js-cookie";

const TokenKey = "Book-Token";
const SharedCookieDomains = ["coursegate.cn", "coursegate.local"];

function getSharedCookieDomain() {
  const hostname = window.location.hostname;
  return SharedCookieDomains.find(
    (domain) => hostname === domain || hostname.endsWith(`.${domain}`)
  );
}

function getTokenCookieOptions() {
  const options = { path: "/" };
  const domain = getSharedCookieDomain();

  if (domain) {
    options.domain = domain;
  }

  return options;
}

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  const options = getTokenCookieOptions();

  // 清理旧的主机级 Cookie，避免它与根域 Cookie 同名时读取结果不确定。
  if (options.domain) {
    Cookies.remove(TokenKey, { path: "/" });
  }

  return Cookies.set(TokenKey, token, options);
}

export function removeToken() {
  Cookies.remove(TokenKey, { path: "/" });
  const domain = getSharedCookieDomain();

  if (domain) {
    return Cookies.remove(TokenKey, {
      path: "/",
      domain
    });
  }
}
